import { OrderFormValues } from '../typings'
import { computeRecurrencePeriod } from './computeRecurrencePeriod'

export function computeRecurrenceUpdateRequest(
  orderFormValues: OrderFormValues,
): uui.domain.ui.forms.RecurrenceUpdateRequest | null {
  if (orderFormValues.recurrenceSettings.recurrencePeriod.recurrenceType === 'NO_REPEAT') {
    return {
      // This is a special case when a user removes recurrence settings
      recurrencePeriod: {
        recurrenceType: 'DAILY',
      },
      endType: 'NEVER',
      numOfRecurrences: -1,
      endDate: null,
    }
  }

  return {
    recurrencePeriod: computeRecurrencePeriod(orderFormValues.recurrenceSettings.recurrencePeriod),
    ...computeEnd(orderFormValues.recurrenceSettings.recurrenceEnd),
  }
}

function computeEnd(
  recurrenceEnd: uui.domain.client.rm.RecurrenceEnd,
):
  | uui.domain.ui.forms.RecurrenceUpdateRequestAfterNumber
  | uui.domain.ui.forms.RecurrenceUpdateRequestOnDate
  | uui.domain.ui.forms.RecurrenceUpdateRequestNever {
  switch (recurrenceEnd.endType) {
    case 'ON_DATE':
      return { endDate: recurrenceEnd.endDate, endType: 'ON_DATE', numOfRecurrences: -1 }
    case 'AFTER_NUMBER':
      return {
        numOfRecurrences: recurrenceEnd.numOfRecurrencesRequired,
        endType: 'AFTER_NUMBER',
        endDate: null,
      }
    case 'NEVER':
      return { endType: 'NEVER', numOfRecurrences: -1, endDate: null }
  }
}
